"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceGuidePricingOperation = void 0;
var __1 = require("../..");
var basePricingOperation_1 = require("./basePricingOperation");
var PriceGuidePricingOperation = /** @class */ (function (_super) {
    __extends(PriceGuidePricingOperation, _super);
    function PriceGuidePricingOperation(_a) {
        var superParams = __rest(_a, []);
        return _super.call(this, superParams) || this;
    }
    Object.defineProperty(PriceGuidePricingOperation.prototype, "searchMode", {
        get: function () {
            return this.strategy.base.tactic.parameterType === 'percentile' ? 'percentile' : 'rank';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PriceGuidePricingOperation.prototype, "parameterValue", {
        get: function () {
            return Number(this.strategy.base.tactic.parameter);
        },
        enumerable: false,
        configurable: true
    });
    PriceGuidePricingOperation.prototype.execute = function (priceGuide) {
        var attribute = (this.article.isShiny
            ? "Foil".concat(this.strategy.base.tactic.parameter)
            : "".concat(this.strategy.base.tactic.parameter));
        var priceGuideValue = Number(priceGuide[attribute]);
        if (!priceGuideValue)
            throw new Error('Could not find a base price guide value');
        var priceModification = this.getNewPrice(priceGuideValue);
        if (!priceModification.newPrice)
            throw new Error('Could not find a new price');
        priceModification.newPrice = priceModification.newPrice * this.playsetCoefficient(false);
        var priceReport = {
            price: priceModification.newPrice,
            pricingStrategy: this.strategy,
            base: {
                type: 'priceGuide',
                value: priceGuideValue,
                metric: this.strategy.base.tactic.parameter,
                usedBulkPrice: priceModification.usedBulkPrice,
                hitDecreaseCap: priceModification.usedBulkPrice,
                hitIncreaseCap: priceModification.hitIncreaseCap,
                freshness: __1.DataFreshness.twoHours,
            },
        };
        return priceReport;
    };
    return PriceGuidePricingOperation;
}(basePricingOperation_1.BasePricingOperation));
exports.PriceGuidePricingOperation = PriceGuidePricingOperation;
//# sourceMappingURL=priceGuidePricingOperation.js.map